import { initializeApp, getApps } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA5WsMBt134CF9IDyfQ3PA3ZRGftbSHJgE",
  authDomain: "klarr-4025f.firebaseapp.com",
  projectId: "klarr-4025f",
  storageBucket: "klarr-4025f.firebasestorage.app",
  messagingSenderId: "795407107296",
  appId: "1:795407107296:web:7ece02096b7a1a056fbc85",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
